import { Component, OnInit } from "@angular/core";
import { UsersService } from "@service/admin/users.service";
import { ToastrService } from "ngx-toastr";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal-pay-pix",
  templateUrl: "./modal-pay-pix.component.html",
  styleUrls: ["./modal-pay-pix.component.scss"],
})
export class ModalPayPixComponent implements OnInit {
  id: number;

  constructor(
    private usersService: UsersService,
    private toastService: ToastrService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {}

  pay(date: any) {
    console.log(this.id);
    this.usersService.payRequest(this.id, date).subscribe((res) => {
      if (res.msg === "OK") {
        this.toastService.success("Data de pagamento atualizada com sucesso!");
        this.activeModal.close();
      } else {
        this.toastService.error("Erro ao atualizar data de pagamento!");
      }
    });
  }
}
